var _path, _rect, _rect2, _rect3, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStore({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 350,
    viewBox: "0 0 400 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.599 171.445C84.7174 172.868 97.8453 172.485 107.611 162.558C113.239 169.401 122.48 174.487 139.144 174.487C151.958 174.487 160.721 167.733 166.132 161.369C172.017 167.528 181.715 173.988 196.478 173.988C210.842 173.988 219.987 167.925 225.537 161.881C230.979 167.882 239.826 173.903 253.413 173.903C266.24 173.903 275.766 168.212 282.037 161.033C292.386 172.75 306.188 172.562 312.182 172.489C328.433 172.275 336.11 164.388 339.689 157.813C352.255 134.714 334.442 90.8719 317.282 58.1596C312.052 48.1923 302.121 42 291.365 42H93.2041C81.9266 42 71.7632 48.6579 66.6784 59.3785C51.7381 90.8744 36.4003 133.234 48.1807 156.147C51.3469 162.303 57.9776 169.952 71.599 171.445ZM80.8651 66.9964C83.2336 62.0061 87.9613 58.9083 93.2044 58.9083H291.366C296.366 58.9083 300.979 61.7783 303.407 66.3986C323.889 105.452 332.522 137.233 325.934 149.34C325.115 150.849 322.616 155.44 311.987 155.579C301.308 155.715 293.92 153.521 289.298 142.174C288.013 139.017 284.959 136.893 281.83 137.081C278.601 137.157 275.733 139.307 274.581 142.521C274.051 144 268.944 156.993 253.414 156.993C238.355 156.993 233.444 145.278 232.966 144.033C231.793 140.747 228.834 138.577 225.535 138.577C225.513 138.577 225.491 138.577 225.469 138.577C222.145 138.607 219.186 140.836 218.06 144.162C218.016 144.291 213.484 157.079 196.479 157.079C179.384 157.079 173.288 143.967 173.074 143.495C171.791 140.47 168.954 138.554 165.838 138.544C165.831 138.544 165.822 138.544 165.816 138.544C162.708 138.544 159.871 140.503 158.577 143.511C158.331 144.083 152.374 157.577 139.144 157.577C120.609 157.577 118.023 150.364 115.742 144C114.609 140.843 111.821 138.706 108.649 138.564C108.537 138.561 108.425 138.558 108.313 138.558C105.271 138.558 102.48 140.414 101.152 143.353C96.9767 152.6 91.7274 156.652 73.2263 154.621C65.9004 153.822 63.3829 150.48 62.1255 148.033C55.8076 135.74 62.9878 104.689 80.8651 66.9964Z",
    fill: "#EA3377",
    stroke: "#EA3377",
    strokeWidth: 3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 123,
    y: 205,
    width: 29.795,
    height: 51.8714,
    rx: 10,
    fill: "#FF3131"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 178.979,
    y: 205,
    width: 29.795,
    height: 51.8714,
    rx: 10,
    fill: "#93E54B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 234.957,
    y: 205,
    width: 29.795,
    height: 51.8714,
    rx: 10,
    fill: "#68ADE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78 160V273C78 289.569 91.4315 303 108 303H280C296.569 303 310 289.569 310 273V160",
    stroke: "#EA3377",
    strokeWidth: 20
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore);
export default __webpack_public_path__ + "static/media/store.3f42645fb0480ef485901eabaa843448.svg";
export { ForwardRef as ReactComponent };